module.exports = __webpack_public_path__ + "static/media/img.1b6bae45.jpg";